import { render, staticRenderFns } from "./CompanyOEMainDetails.vue?vue&type=template&id=a1c82e22&scoped=true&"
import script from "./CompanyOEMainDetails.vue?vue&type=script&lang=js&"
export * from "./CompanyOEMainDetails.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOEMainDetails.vue?vue&type=style&index=0&id=a1c82e22&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c82e22",
  null
  
)

export default component.exports